import { BaseModalUpdateComponent, BaseUpdateComponent, ModalContainerService, ModalService } from 'yt-ng-framework';
import { Component, OnInit, ViewChild } from "@angular/core";
import { VrstaStavki } from './vrsta-stavki';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { FormControl, FormGroup } from '@angular/forms';
import { VrstaStavkiUpdateComponent } from './vrsta-stavki-update.component';

@Component({
    selector: 'yt-vrsta-stavki-modal-update',
    templateUrl: './vrsta-stavki-modal-update.component.html'
})



export class VrstaStavkiModalUpdateComponent extends BaseModalUpdateComponent<VrstaStavki> implements OnInit{
    constructor(
        protected modalContainerService: ModalContainerService<VrstaStavki>,
        protected activeModal: NgbActiveModal,
        protected modalService: ModalService
    ){
        super(modalContainerService, activeModal,modalService);
    }

    headerFormGroup=new FormGroup({JezikID:new FormControl(1)});
    @ViewChild('baseUpdate', { static: true }) VrstaStavkiUpdate: VrstaStavkiUpdateComponent;

    ngOnInit(){
        
    }

    onJezikSelect(value){
        if (value){
            let close: boolean = true;
            if (this.baseUpdateComponent.Item.JezikID && !this.baseUpdateComponent.canDeactivate())
                if(confirm('Podaci nisu sačuvani. Ako nastavite, podaci će biti izgubljeni.'))
                    close = true;
                else
                    close = false;

            if(this.baseUpdateComponent.Item.JezikID && this.baseUpdateComponent.Item.JezikID!=value.ID && close){
                // this.baseUpdateComponent.Load1(this.baseUpdateComponent.Item.ID, value.ID)
                this.VrstaStavkiUpdate.Load(this.baseUpdateComponent.Item.ID, value.ID).subscribe(() => {});
            }           
        }

    }
}